/*
 * Esse arquivo deve conter funções para manipular o localStorage
 * com métodos genéricos para armazenar e recuperar dados com os tipos
 * especificados.
 */

export function getArrayFromStorage<T>(key: string): T[] {
  const storedValue = localStorage.getItem(key)
  return storedValue ? (JSON.parse(storedValue) as T[]) : ([] as T[])
}

export function setArrayToStorage<T>(key: string, value: T[]): void {
  localStorage.setItem(key, JSON.stringify(value))
}

export function getObjectFromStorage <T>  (key: string): T | null {
  try {
    const storedTenant = localStorage.getItem(key)
    return storedTenant ? JSON.parse(storedTenant) as T : null
  } catch (error) {
    console.error(`Error parsing ${key} from localStorage:`, error)
    localStorage.removeItem(key)
    return null
  }
}

export function setObjectToStorage (key: string, obj: unknown | null) {
  if (obj) {
    localStorage.setItem(key, JSON.stringify(obj))
  } else {
    localStorage.removeItem(key)
  }
}